import { createFileRoute } from "@tanstack/react-router";
import { LeagueSettings, LeagueSettingsPending } from "@/features/account";
import { getLeagueSettingsAdmission } from "@/features/account/records";
import { VerifiedSession } from "@/session/product-session";

export const Route = createFileRoute("/_site/leagues/$leagueId/settings")({
  loader: ({ params, abortController }) =>
    getLeagueSettingsAdmission({
      data: params,
      signal: abortController.signal,
    }),
  staleTime: 0,
  gcTime: 0,
  pendingComponent: LeagueSettingsPending,
  head: () => ({
    meta: [
      { title: "League settings | Softmax" },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  component: LeagueSettingsPage,
});

function LeagueSettingsPage() {
  const { leagueId } = Route.useParams();
  const { sessionUserId } = Route.useLoaderData();
  return (
    <main
      id="main"
      data-shell-page
      tabIndex={-1}
      className="focus:outline-none"
    >
      <VerifiedSession
        sessionUserId={sessionUserId}
        fallback={<LeagueSettingsPending />}
      >
        <LeagueSettings
          key={`${sessionUserId}:${leagueId}`}
          leagueId={leagueId}
        />
      </VerifiedSession>
    </main>
  );
}
